import type {ReactElement} from 'react';
import React from 'react';
import {MenuLayout} from '@Components/menu-layout';
import {LayoutOptions} from '@Components/contextual-menu/components/contextual-menu-layout-button';
import styles from './contextual-menu-layout-selector.module.scss';

interface ContextualMenuLayoutSelectorProps {
  layoutFor: LayoutOptions;
  selectedLayoutId: string;
  layoutNames: Array<string>;

  onClick(layout: string): void;
  isMobileVersion?: boolean;
}

export function ContextualMenuLayoutSelector({isMobileVersion = true, ...props}: ContextualMenuLayoutSelectorProps): ReactElement {
  const getFolderName = (): string => {
    switch (props.layoutFor) {
      case LayoutOptions.MENU:
        return 'menu';
      case LayoutOptions.SCHEDULE:
        return 'schedule';
      default:
        return '';
    }
  };

  return (
    <MenuLayout
      className={`${isMobileVersion ? `flex-h-row spacing-p-r-4 spacing-p-l-4 spacing-m-0 ${styles.mobileContainer}` : styles.layoutStyles}`}
      itemClassName={isMobileVersion ? styles.mobileStyles : ''}
      layout={props.selectedLayoutId}
      layoutPath={`${window.PMW.util.asset_url(`images/postermaker/${getFolderName()}-layouts/`)}`}
      styleImages={props.layoutNames}
      onLayoutSelected={(selectedLayout): void => {
        return props.onClick(selectedLayout);
      }}
      big
      showSmallImages={!isMobileVersion}
    />
  );
}
